import { createSlice } from "@reduxjs/toolkit";
import { BusinessDetailsData } from "../types/VerBusinessDetailsType";
import { getLocalBank } from "../action/getLocalBank";

const initialState: BusinessDetailsData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const verLocalBankDetailsSlice = createSlice({
  name: "verLocalBankDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocalBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocalBank.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // // console.log("DATA createAppSlice", action);
      })
      .addCase(getLocalBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const verLocalBankDetailsReducer = verLocalBankDetailsSlice.reducer;
